export default __webpack_public_path__ + "static/media/higher_primary_hi_ident.b92f6e17.svg";